import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ModalHeader,
} from "./Atom"
import { useSelector } from "react-redux"
import { modalContainerStyles } from "../Atom"
import { makeFullName } from "../../../../helper/utils"

const UserDeletionConfirmation = (props: any) => {
  const { open, setOpen, isGroup, name, deleteUser } = props

  const handleClose = () => {
    // type == "new" ? handleRemoveNewTab() : type == "edit" ? setCurrentActiveEditBucketName(-1) : type == "del" ? "" : "";
    setOpen(false)
  }

  return (
    <Modal
      sx={{
        "& .css-5ta5m7 ": { width: "fit-content" },
        "& .MuiTypography-root": { whiteSpace: "nowrap" },
      }}
      open={open}
      onClose={() => {
        handleClose()
      }}
      aria-labelledby="groupInfo-modal-title"
      aria-describedby="groupInfo-modal-description"
    >
      <Box sx={modalContainerStyles}>
        <ModalHeader>
          <Typography variant={"h2"} fontSize={"18px"} fontWeight={500}>
            Delete {isGroup ? "Group" : "User"}
          </Typography>
          <CloseIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              handleClose()
            }}
          />
        </ModalHeader>

        <Typography
          id="modal-modal-title"
          fontSize={"18px"}
          fontWeight={500}
          sx={{
            padding: "10px 24px 30px 24px",
            textAlign: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <>
            Are you sure to delete the {isGroup ? "group " : "user "}
            <b>{name}</b> ?
          </>
        </Typography>

        <br />
        {/* <Divider /> */}

        <ButtonContainer>
          <CancelButton
            onClick={() => {
              handleClose()
            }}
          >
            <Typography color={"#4A79E7"}>Cancel</Typography>
          </CancelButton>
          <ConfirmButton
            onClick={() => {
              deleteUser()
              handleClose()
            }}
          >
            <Typography color={"#ffffff"}>Yes</Typography>
          </ConfirmButton>
        </ButtonContainer>
      </Box>
    </Modal>
  )
}

export default UserDeletionConfirmation
